import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import moment from "moment";
import { getItemsRequest } from "src/modules/spItems/api";
import { twMerge } from "tailwind-merge";
import { selectItem } from "src/modules/spItems/selectors";
import AuditEmplyeesSingle from "./AuditEmplyeesSingle";
import ExportToExcel from "src/modules/exelExport";
import { addUsers } from "src/modules/users/actions";
import OwdEmployeesSingle from "./OwdEmployeesSingle";
import DownloadEmployesTableSingle from "./DownloadEmployesTableSingle";
import {
  activityAnalysisListName,
  myDocumentsListName,
  versionsByDocumentListName,
} from "src/api/config";
import { notificationsListName } from "src/api/config/notifications.config";
import Loading from "src/components/Loading";
import { RootState } from "src/store/rootReducer";
import { notificationStatuses } from "src/api/config/systemSwitch";
import { useStatusContext } from "src/pages/DashboardPage/acadia/notificationPage";

export default function EmployeeReportSingle({
  versionView,
  setQuery,
  query,
  card
}: any) {
  const [exportData, setExportData] = useState<any>({});
  const [typeReport, setTypeReport] = useState("audit");
  const [customLoading, setCustomLoading] = useState(true);
  const [auditItems, setAuditItems] = useState<any>([]);
  const [owdItems, setOwdItems] = useState<any>([]);
  const [downloadItems, setDownloadItems] = useState<any>([]);
  const dispatch = useAppDispatch();
  const statusUsers: string = useAppSelector(
    (state: RootState) => state.users.status
  );
  const { status } = useStatusContext();

  useEffect(() => {
    setExportData({});
    setCustomLoading(true);
    if (typeReport === "audit") {
      getItemsRequest({
        listName: notificationsListName,
        viewFields: [
          "ID",
          "Document",
          "ReviewDate",
          "Completed",
          "Created",
          "EmployeeEmail",
          "DocumentCode",
          "TestAnswerRate",
          "Employee",
          "Title",
          "VersionDocument"
        ],
        filters: {
          Document: card.ID,
          NotificationType: [
            notificationStatuses.acquainted,
            notificationStatuses.acquaintedTest,
            notificationStatuses.familiarization,
          ],
        },
        populateFields: ['Document', 'VersionDocument']
      }).then((results: any) => {
        let emails: any = [];
        setAuditItems([...results.items]);
        results.items.map((item: any) => {
          emails = [...emails, item.EmployeeEmail.toLowerCase()];
        });
        dispatch(addUsers(emails));
        setCustomLoading(false);
      });
    }
    if (typeReport === "owd") {
      getItemsRequest({
        listName: notificationsListName,
        viewFields: [
          "ID",
          "Document",
          "ReviewDate",
          "Completed",
          "TemplateOWDID",
          "Created",
          "EmployeeEmail",
          "TestedEmployee",
          "isPass",
          "TestAnswerRate",
          "DocumentCode",
          "Employee",
          "AuthorEmail",
          "Title",
          "VersionDocument"
        ],
        filters: {
          Document: card.ID,
          NotificationType: [
            notificationStatuses.getOWD,
            notificationStatuses.OWD,
          ],
        },
        populateFields: ['Document', 'VersionDocument']
      }).then((results: any) => {
        setOwdItems([...results.items]);
        let emails: any = [];
        results.items.map((item: any) => {
          if (item.EmployeeEmail) {
            emails = [...emails, item.EmployeeEmail.toLowerCase()];
          }
          if (item.TestedEmployee) {
            emails = [...emails, item.TestedEmployee.toLowerCase()];
          }
          if (item.AuthorEmail) {
            emails = [...emails, item.AuthorEmail.toLowerCase()];
          }
        });
        dispatch(addUsers(emails));
        setCustomLoading(false);
      });
    }
    if (typeReport === "download") {
      getItemsRequest({
        listName: activityAnalysisListName,
        viewFields: [
          "ID",
          "Document",
          "DocumentCode",
          "Created",
          "Author",
          "ActiveType",
        ],
        filters: {
          Document: card.ID,
          ActiveType: ["Download", "Print"],
          isActive: true,
        },
      }).then((results: any) => {
        setDownloadItems([...results.items]);
        setCustomLoading(false);
        let emails: any = [];
        results.items.map((item: any) => {
          if (item.Author) {
            emails = [...emails, item.Author.get_email().toLowerCase()];
          }
        });
        dispatch(addUsers(emails));
      });
    }
  }, [typeReport, status]);

  return (
    <FlexCol className="w-full gap-5">
      <FlexRow className="w-full gap-5">
        <FlexRow className="w-9/12 gap-2 p-1.5 shadow-custom bg-white w-full rounded">
          <FlexCol
            onClick={() => setTypeReport("audit")}
            className={twMerge(
              "items-center py-2 px-5 cursor-pointer w-1/3",
              (typeReport === "audit" && "text-[#012169] font-bold") ||
              "text-[#637381]"
            )}
          >
            Ознакомление
          </FlexCol>
          <FlexCol
            onClick={() => setTypeReport("owd")}
            className={twMerge(
              "items-center py-2 px-5 cursor-pointer w-1/3",
              (typeReport === "owd" && "text-[#012169] font-bold") ||
              "text-[#637381]"
            )}
          >
            OWD
          </FlexCol>
          <FlexCol
            onClick={() => setTypeReport("download")}
            className={twMerge(
              "items-center py-2 px-5 cursor-pointer w-1/3",
              (typeReport === "download" && "text-[#012169] font-bold") ||
              "text-[#637381]"
            )}
          >
            Скачивания
          </FlexCol>
        </FlexRow>
        {(statusUsers !== "LOADING" && (
          <FlexRow className="lg:w-3/12 sm:w-1/3 justify-end">
            <ExportToExcel
              exportData={exportData}
              fileName={`Document #${card.ID} Report`}
              type="employees_report"
            />
          </FlexRow>
        )) || (
            <FlexRow className="lg:w-3/12 sm:w-1/3 justify-center items-center">
              <FlexCol className="h-[24px]">
                <Loading />
              </FlexCol>
            </FlexRow>
          )}
      </FlexRow>
      {typeReport === "audit" && (
        <AuditEmplyeesSingle
          loading={customLoading}
          exportData={exportData}
          setQuery={setQuery}
          query={query}
          cardVersion={card.Ver}
          setExportData={setExportData}
          auditItems={auditItems}
          setAuditItems={setAuditItems}
        />
      )}
      {typeReport === "owd" && (
        <OwdEmployeesSingle
          exportData={exportData}
          setQuery={setQuery}
          query={query}
          cardVersion={card.Ver}
          setExportData={setExportData}
          owdItems={owdItems}
          setOwdItems={setOwdItems}
        />
      )}
      {typeReport === "download" && (
        <DownloadEmployesTableSingle
          exportData={exportData}
          cardVersion={card.Ver}
          setExportData={setExportData}
          data={downloadItems}
        />
      )}
    </FlexCol>
  );
}
